/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_Forearm_LeftInputs */

const en_us2_body_measures_site_forearm_left = /** @type {(inputs: Body_Measures_Site_Forearm_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left forearm`)
};

const pt_br2_body_measures_site_forearm_left = /** @type {(inputs: Body_Measures_Site_Forearm_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antebraço esq.`)
};

const es_419_body_measures_site_forearm_left = /** @type {(inputs: Body_Measures_Site_Forearm_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antebrazo izq.`)
};

const pt_pt2_body_measures_site_forearm_left = /** @type {(inputs: Body_Measures_Site_Forearm_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antebraço esq.`)
};

const fr_fr2_body_measures_site_forearm_left = /** @type {(inputs: Body_Measures_Site_Forearm_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant-bras g.`)
};

const de_de2_body_measures_site_forearm_left = /** @type {(inputs: Body_Measures_Site_Forearm_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterarm li.`)
};

const it_it2_body_measures_site_forearm_left = /** @type {(inputs: Body_Measures_Site_Forearm_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avambraccio sx`)
};

/**
* | output |
* | --- |
* | "Left forearm" |
*
* @param {Body_Measures_Site_Forearm_LeftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_forearm_left = /** @type {((inputs?: Body_Measures_Site_Forearm_LeftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_Forearm_LeftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_forearm_left(inputs)
	if (locale === "es-419") return es_419_body_measures_site_forearm_left(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_forearm_left(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_forearm_left(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_forearm_left(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_forearm_left(inputs)
	return en_us2_body_measures_site_forearm_left(inputs)
});
export { body_measures_site_forearm_left as "body-measures.site_forearm_left" }